import useFetchDocClasses from '@components/features/docClass/hooks/useFetchDocClasses';
import { useAtomValue } from 'jotai';
import { currentDocClassAtom } from '@js/store/appAtoms';
import { DEFAULT_DOC_CLASS } from '@routing/appUrls';

const useDocClasses = () => {
    const { data } = useFetchDocClasses();
    const currentDocClass = useAtomValue(currentDocClassAtom);
    const currentDocClassItem = data && data.list ? data?.list.find((docClassItem) => docClassItem.name === currentDocClass) : undefined;
    const defaultDocClassItem = data && data.list ? data?.list.find((docClassItem) => docClassItem.name === DEFAULT_DOC_CLASS) : undefined;

    const docClasses = data && !!data?.list ? data.list : [];

    const otherDocClasses = docClasses.filter((docClassItem) => docClassItem.name !== currentDocClass);

    return {
        currentDocClassItem,
        defaultDocClassItem,
        docClasses,
        otherDocClasses,
    };
};

export default useDocClasses;
